import AdviserProfilesApi from '../../../../../core/api/AdviserProfilesApi'
import { toast } from 'react-toastify'

export const SUBMITTING_APPROVE_PROFILE = 'SUBMITTING_APPROVE_PROFILE'
export const SUBMITTED_APPROVE_PROFILE = 'SUBMITTED_APPROVE_PROFILE'
export const SUBMIT_APPROVE_PROFILE = 'SUBMIT_APPROVE_PROFILE'

const api = new AdviserProfilesApi()

export const submittingProfileForApproval = () => ({
  type: SUBMITTING_APPROVE_PROFILE
})

export function approveProfile(adviserId) {

  return (dispatch) => {
    dispatch(submittingProfileForApproval())

    api.approveProfile(adviserId)
      .then(() => {
        dispatch({ type: SUBMITTED_APPROVE_PROFILE })
        toast.info('Profile Approved', {
          autoClose: 10000
        })
      })
      .catch(err => {
        console.error('API FAILED', err)
      })
  }
}
